import React from 'react';
// import {
//     FaBook,
//     FaUserGraduate,
//     FaBitcoin,
//     FaUserTie,
//     FaChartBar,
//     FaBookReader,
//     FaGraduationCap,
//     FaBars,
//     FaUserCog,
//     FaPowerOff,
//     FaAngleDown,
//     FaUsers
// } from "react-icons/fa"; //Font Awesome 5
import {
    Card,
    Row,
    Col,
    Statistic,
    Typography
} from 'antd';

function SimpleDashboardCard({ cardData }) {
    // console.log(cardData);
    return (
        <div className='dasboardcard-container'>
            <Card
                bordered={false}
                bodyStyle={{
                    background: '#f7f7f7',
                    padding: '0px',
                    position: 'relative',
                }}
            >
                <Row justify="center">
                    <Col xs={24}>
                        <Statistic
                            title={
                                <Typography.Paragraph
                                    style={{
                                        padding: 0,
                                        margin: 0,
                                        textTransform: 'capitalize',
                                        ...(cardData.label.includes('Total') ? {fontSize: '20px', fontWeight: 'bold' }: {fontSize: '16px'})
                                    }}>{cardData.label}</Typography.Paragraph>
                            }
                            value={cardData.value}
                            precision={0}
                            valueStyle={{
                                textAlign: 'center',
                                ...(cardData.label.includes('Total') && { fontWeight: 'bold'}),
                                color: '#483D8B'
                            }}
                        />
                    </Col>
                </Row>
            </Card>
        </div>
    )
}

export default SimpleDashboardCard